import { render } from "./BileteleMele.vue?vue&type=template&id=2b558ecf&scoped=true"
import script from "./BileteleMele.vue?vue&type=script&lang=js"
export * from "./BileteleMele.vue?vue&type=script&lang=js"

import "./BileteleMele.vue?vue&type=style&index=0&id=2b558ecf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b558ecf"]])

export default __exports__